<div class="card">
    <app-header titulo="Equipamentos" descricao="Integração de equipamentos"></app-header>

    <p-table [value]="equipamentos" [globalFilterFields]="['cdEquiptoErp','deEquipto','cdTpEquip','cdCcustoErp','cdModelo']"
                     styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
                     [rowsPerPageOptions]="[10,20,50,100]" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                     currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" dataKey="cdEquiptoErp" 
                     [scrollable]="true" scrollDirection="both" #dt>

        <ng-template pTemplate="caption">
            <div class="flex justify-content-end flex-wrap">
                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3 mr-3" pButton (click)="exportar()" style="font-size: 1.0rem" [loading]="loadingSincronizar" icon="pi pi-file-excel" label="Exportar"></button>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                    </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="getAll()" [loading]="loading"></button>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>Equipamento</th>
                <th>Descrição</th>
                <th>Tipo</th>
                <th>Centro Custo</th>
                <th>Modelo</th>
                <th>Dt Recebido</th>
                <th>Status</th>
                <th>Dt Integrado</th>
                <th>Mensagem</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-equipamento>
            <tr>
                <td>{{ equipamento.cdEquiptoErp }}</td>
                <td>{{ equipamento.deEquipto }}</td>
                <td>{{ equipamento.cdTpEquip }}</td>
                <td>{{ equipamento.cdCcustoErp }}</td>
                <td>
                    <button pButton pRipple icon="pi pi-search" 
                            class="p-button-rounded p-button-text" 
                            style="width: 1.5rem; height: 1.5rem; padding: 0;"
                            (click)="visualizarDetalhesModelo(equipamento)" 
                            pTooltip="Ver detalhes do modelo" tooltipPosition="top"></button>
                    {{ equipamento.cdModelo }}
                </td>
                <td>{{ equipamento.dtEnvioErp | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td><app-tag-status [status]="equipamento.fgStatusInteg"></app-tag-status></td>
                <td>{{ equipamento.dtIntegPims | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ equipamento.mensagem }}</td>
            </tr>
        </ng-template>

    </p-table>
</div>

<p-dialog header="Detalhes do Modelo" [(visible)]="displayDetalhesDialog" [modal]="true" [style]="{width: '25vw', maxHeight: '60vh'}" [draggable]="false" [resizable]="false" [closable]="false">
    <ng-template pTemplate="header">
        <div class="flex justify-content-between align-items-center w-full">
            <span class="font-bold text-xl">Detalhes do Modelo</span>
            <button pButton label="Fechar" icon="pi pi-times" (click)="displayDetalhesDialog = false" class="p-button-text p-button-sm"></button>
        </div>
    </ng-template>
    
    <div *ngIf="equipamentoSelecionado" class="p-fluid">
        <div class="field grid">
            <label class="col-12 mb-2 md:col-4 md:mb-0 font-bold">Modelo:</label>
            <div class="col-12 md:col-8">
                {{ equipamentoSelecionado.cdModelo }} - {{ equipamentoSelecionado.deModelo }}
            </div>
        </div>
        
        <div class="field grid">
            <label class="col-12 mb-2 md:col-4 md:mb-0 font-bold">Gp Operativo:</label>
            <div class="col-12 md:col-8">
                {{ equipamentoSelecionado.cdGrupoOp }} - {{ equipamentoSelecionado.deGrupoOp }}
            </div>
        </div>
        
        <div class="field grid">
            <label class="col-12 mb-2 md:col-4 md:mb-0 font-bold">Clas Potência:</label>
            <div class="col-12 md:col-8">
                {{ equipamentoSelecionado.cdClasPot }} - {{ equipamentoSelecionado.deClasPot }}
            </div>
        </div>
        
        <div class="field grid">
            <label class="col-12 mb-2 md:col-4 md:mb-0 font-bold">Marca:</label>
            <div class="col-12 md:col-8">
                {{ equipamentoSelecionado.cdMarca }} - {{ equipamentoSelecionado.deMarca }}
            </div>
        </div>
    </div>
</p-dialog>